var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { BwElement } from './base/bw-element.js';
let BwRadioGroup = class BwRadioGroup extends BwElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.value = '';
        this.disabled = false;
        this.options = [];
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.hasAttribute('role'))
            this.setAttribute('role', 'radiogroup');
    }
    _onChange(value) {
        if (this.value === value)
            return;
        this.value = value;
        this.dispatchEvent(new CustomEvent('bw-radio-change', {
            detail: { value }, bubbles: true, composed: true,
        }));
    }
    render() {
        return html `${this.options.map((opt) => {
            const checked = opt.value === this.value;
            const disabled = this.disabled || !!opt.disabled;
            return html `
        <label class="bw-radio-row">
          <input class="bw-radio-native" type="radio"
            name=${this.name || nothing} value=${opt.value}
            .checked=${checked} ?disabled=${disabled}
            @change=${() => this._onChange(opt.value)}>
          <span class="bw-radio-dot" aria-hidden="true"></span>
          <span class="bw-radio-text">
            <span class="bw-radio-label">${opt.label}</span>
            ${opt.description ? html `<span class="bw-radio-desc">${opt.description}</span>` : nothing}
          </span>
        </label>`;
        })}`;
    }
};
__decorate([
    property({ type: String })
], BwRadioGroup.prototype, "name", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwRadioGroup.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwRadioGroup.prototype, "disabled", void 0);
__decorate([
    property({ attribute: false })
], BwRadioGroup.prototype, "options", void 0);
BwRadioGroup = __decorate([
    customElement('bw-radio-group')
], BwRadioGroup);
export { BwRadioGroup };
// Note: `bw-radio` tag is registered as an alias for consumers who want a
// single row; for W1 the group renders its own rows. Registered as a thin
// element so `customElements.get('bw-radio')` passes.
let BwRadio = class BwRadio extends BwElement {
    constructor() {
        super(...arguments);
        this.value = '';
        this.label = '';
        this.description = '';
        this.checked = false;
        this.disabled = false;
    }
    render() {
        return html `
      <label class="bw-radio-row">
        <input class="bw-radio-native" type="radio" value=${this.value}
          .checked=${this.checked} ?disabled=${this.disabled}>
        <span class="bw-radio-dot" aria-hidden="true"></span>
        <span class="bw-radio-text">
          <span class="bw-radio-label">${this.label}</span>
          ${this.description ? html `<span class="bw-radio-desc">${this.description}</span>` : nothing}
        </span>
      </label>`;
    }
};
__decorate([
    property({ type: String })
], BwRadio.prototype, "value", void 0);
__decorate([
    property({ type: String })
], BwRadio.prototype, "label", void 0);
__decorate([
    property({ type: String })
], BwRadio.prototype, "description", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwRadio.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BwRadio.prototype, "disabled", void 0);
BwRadio = __decorate([
    customElement('bw-radio')
], BwRadio);
export { BwRadio };
//# sourceMappingURL=bw-radio.js.map